import palette from '../palette';

export default {
  text: {
    textTransform: 'capitalize',
  },
  outlined: {
    textTransform: 'capitalize',
    // backgroundColor: '#ffffff',
    // border: '1px solid #d0d0d0',
    // color: '#333333',
    // borderRadius: '4px',
    // padding: '8px 16px',
    // fontWeight: '400',
    // '&:hover': {
    //   backgroundColor: '#f5f5f5',
    //   border: '1px solid #b0b0b0',
    // },
    // '&:focus': {
    //   backgroundColor: '#ffffff',
    //   border: '1px solid #d0d0d0',
    // },
  },
  contained: {
    textTransform: 'capitalize',
  },
  outlinedSizeSmall: {
    fontSize: '0.8125rem',
  },
  containedSizeSmall: {
    fontSize: '0.8125rem',
  },
  // Soft grey background for default contained buttons to match legacy look
  containedInherit: {
    backgroundColor: '#eceff3',
    color: '#12161B',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#e2e7ee',
      boxShadow: 'none',
    },
  },
  outlinedInherit: {
    backgroundColor: 'transparent',
    color: '#12161B !important',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
  },
  //create color default button like mui v4
  outlinedDefault: {
    backgroundColor: '#ffffff',
    border: '1px solid #d0d0d0',
    color: '#333333',
    borderRadius: '4px',
    fontWeight: '400',
    fontWeight: '500',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
    '&:focus': {
      backgroundColor: '#ffffff',
      border: '1px solid #d0d0d0',
    },
  },
  // Apply consistent hover color for primary contained buttons across the app
  containedPrimary: {
    '&:hover': {
      backgroundColor: palette.primary.dark,
    },
  },
};
